import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Modal, Spacer, Typography } from '@telus-uds/components-web';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button as ActionButton } from './css';

const QuoteReference = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: {
      confirmationDialog,
      markAsQuoteReference,
      removeAsQuoteReference
    },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [modalData, setModalData] = useState({
    isOpen: false,
    message: ''
  });
  const [referenceFlag, setReferenceFlag] = useState(false);

  const handleQuoteReference = () => {
    const body = {
      isQuoteReference: referenceFlag
    };
    request.put(`/orders/${id}`, body).then(() => {
      setModalData({
        isOpen: false,
        message: ''
      });
      fetchOrders();
    });
  };

  return (
    <>
      {!isQuoteReference && (
        <ActionButton
          className="action-button"
          onClick={() => {
            setReferenceFlag(true);
            setModalData({
              isOpen: true,
              message: 'Are you sure you want to save this quote as reference?'
            });
          }}
        >
          {markAsQuoteReference}
        </ActionButton>
      )}
      {isQuoteReference && (
        <ActionButton
          onClick={() => {
            setReferenceFlag(false);
            setModalData({
              isOpen: true,
              message:
                'Are you sure you want to unmark this quote as reference?'
            });
          }}
        >
          {removeAsQuoteReference}
        </ActionButton>
      )}
      <Modal
        isOpen={modalData.isOpen}
        onClose={() => setModalData({ isOpen: false, message: '' })}
      >
        <Typography variant={{ size: 'h2' }}>{confirmationDialog}</Typography>
        <Spacer space={1} />
        <p>{modalData.message}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'low' }}
            onPress={() => setModalData({ isOpen: false, message: '' })}
          >
            {cancelButtonLabel}
          </Button>
          <Button
            type="button"
            variant={{ priority: 'high' }}
            onPress={handleQuoteReference}
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

QuoteReference.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default QuoteReference;
